import { AccountWithColor } from "../dataProviders/DataProvider.tsx";

export function getAccountLabel(account: AccountWithColor): string {
  return (
    account.identification?.iban ??
    account.identification?.accountNumber ??
    account.identification?.other?.[0]?.value ??
    account.productName ??
    account.id ??
    "Unknown account identification"
  );
}
